import {
  BufferTracker,
  Product,
  Client,
  notifyViolations,
} from '@bufferapp/buffer-tracking-browser-ts';
import { selectCurrentOrganizationId } from '~/organizations/selectors';
import { store } from '~/store';
import { IntegrationsContext } from './types';

export const BUTTON_CLICKED = 'integration-button-clicked';
export const MEDIA_ATTACHED = 'integration-media-attached';
export const QUERY_RUN = 'integration-query-run';

const IS_DEVELOPMENT = (): boolean => {
  return (
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
  );
};

notifyViolations(BufferTracker, IS_DEVELOPMENT());

const getTrackingMetadata = () => {
  const organizationId = selectCurrentOrganizationId(store.getState());
  return {
    organizationId,
    clientName: Client.PublishWeb,
    product: Product.Publish,
  };
};

export const sendIntegrationsEvent = (
  event: string,
  context: IntegrationsContext,
  service: string,
  info: string | null = null
): void => {
  service = service.toLowerCase();

  switch (event) {
    case BUTTON_CLICKED:
      {
        const evenButtonClickedData = {
          ...getTrackingMetadata(),
          source: context,
          integration: service,
        };
        BufferTracker.integrationButtonClicked(evenButtonClickedData);
      }
      break;
    case MEDIA_ATTACHED:
      {
        const eventMediaAttachedData = {
          ...getTrackingMetadata(),
          destination: context,
          integration: service,
          mediaType: info || 'no-filled',
        };
        BufferTracker.integrationMediaAttached(eventMediaAttachedData);
      }
      break;
    case QUERY_RUN:
      {
        const eventSearchData = {
          ...getTrackingMetadata(),
          integration: service,
          source: context,
          query: info || 'not-filled',
        };

        BufferTracker.integrationSearchRun(eventSearchData);
      }
      break;
    default:
      break;
  }
};
